var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 0.620117C21.58 0.620117 24 3.00012 24 6.00012C24 8.96012 21.58 11.3701 18.6 11.3701C17.15 11.3701 15.8 10.8101 14.78 9.80012L12 7.34012L9.17 9.85012C8.2 10.8201 6.84 11.3801 5.4 11.3801C2.42 11.3801 0 8.96012 0 6.00012C0 3.04012 2.42 0.620117 5.4 0.620117C6.84 0.620117 8.2 1.18012 9.22 2.20012L12 4.66012L14.83 2.15012C15.8 1.18012 17.16 0.620117 18.6 0.620117ZM7.8 8.39012L10.5 6.00012L7.84 3.65012C7.16 2.97012 6.31 2.62012 5.4 2.62012C3.53 2.62012 2 4.13012 2 6.00012C2 7.87012 3.53 9.38012 5.4 9.38012C6.31 9.38012 7.16 9.03012 7.8 8.39012ZM16.2 3.61012L13.5 6.00012L16.16 8.35012C16.84 9.03012 17.7 9.38012 18.6 9.38012C20.47 9.38012 22 7.87012 22 6.00012C22 4.13012 20.47 2.62012 18.6 2.62012C17.69 2.62012 16.84 2.97012 16.2 3.61012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.5f65415f.svg";
export { ForwardRef as ReactComponent };